import React from "react";
import BackArrowButton from "../../parts/back-arrow-button";
import SignupStepMarker from "../../parts/signup-step-marker";

const OnboardingHeader = ({
  onBack,
  title = "Sign Up",
  active,
  phrase,
  noBack = false,
}) => {
  return (
    <header role="onboarding-header">
      <section>
        {!noBack && <BackArrowButton onBack={onBack} text="" />}
        <h1>{title}</h1>
      </section>
      <SignupStepMarker active={active} phrase={phrase} />
    </header>
  );
};

export default OnboardingHeader;
